import * as React from "react";

import { Box, CssBaseline } from "@mui/material";
import { ThemeContext } from "../context";
import {
  EducationSection,
  FooterSection,
  HeroSection,
  SectorSection,
  TechnologySection,
} from ".";
import ScrollTop from "./ScrollTop";
import OpenSource from "./OpenSource";

const Application = () => {
  return (
    <ThemeContext>
      <CssBaseline />
      <Box>
        <HeroSection />
        <OpenSource />
        <TechnologySection />
        <SectorSection />
        <EducationSection />
        <FooterSection />
      </Box>
      <ScrollTop />
    </ThemeContext>
  );
};

export default Application;
